<!--footer section -->
<!-- 
    Main Footer Component
    - Responsive footer with newsletter, navigation, and contact sections
    - Includes social media links, payment methods, and version info
    - Uses Angular data binding and directives
-->
<footer [class]="class" [ngStyle]="{'background-image': 'url('+ bannerFooter +')'}">
    
    <!-- Newsletter Section -->
    <!-- Conditional newsletter subscription area with modern form design -->
    <div class="newsletter-container" *ngIf="newsletter">
        <div class="newsletter-bg">
            <div class="container">
                <div class="newsletter-wrapper">
                    <div class="row align-items-center">
                        <!-- Newsletter Content Column -->
                        <div class="col-lg-6 col-md-12">
                            <div class="newsletter-content">
                                <!-- Newsletter badge/tag -->
                                <div class="newsletter-badge">Newsletter</div>
                                
                                <!-- Main heading with gradient text effect -->
                                <h2 class="newsletter-heading">
                                    Stay in the <span class="gradient-text">loop</span>
                                </h2>
                                
                                <!-- Newsletter description -->
                                <p class="newsletter-text">
                                    Get the latest updates, exclusive deals, and insider news delivered straight to your inbox.
                                </p>
                            </div>
                        </div>
                        
                        <!-- Newsletter Form Column -->
                        <div class="col-lg-6 col-md-12">
                            <!-- MailChimp subscription form -->
                            <form class="modern-form"
                                action="https://pixelstrap.us19.list-manage.com/subscribe/post?u=5a128856334b598b395f1fc9b&amp;id=082f74cbda"
                                target="_blank" method="post">
                                <div class="form-wrapper">
                                    <!-- Email input with focus effect -->
                                    <div class="input-wrapper">
                                        <input type="email" #name name="EMAIL" id="mce-EMAIL" 
                                            class="modern-input" placeholder="Enter your email" required>
                                        <!-- Animated focus line -->
                                        <div class="input-focus"></div>
                                    </div>
                                    
                                    <!-- Submit button with arrow icon -->
                                    <button type="submit" class="modern-btn">
                                        <span>Subscribe</span>
                                        <!-- Right arrow SVG icon -->
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                            <path d="M5 12h14M12 5l7 7-7 7"/>
                                        </svg>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Main Footer Content -->
    <!-- Primary footer content with brand, navigation, and contact information -->
    <div class="main-footer">
        <div class="container">
            <div class="footer-grid">
                
                <!-- Brand Section -->
                <!-- Company logo, description, and social media links -->
                <div class="footer-brand-section">
                    <!-- Brand/Logo Container -->
                    <div class="brand-container">
                        <div class="logo-wrapper">
                            <!-- Dynamic logo binding -->
                            <img [src]="themeLogo" alt="logo" class="brand-logo">
                        </div>
                        <!-- Brand description with dynamic color and text -->
                        <p class="brand-description" [style.color]="color" [textContent]="txtLeft"></p>
                    </div>
                    
                    <!-- Social Media Section -->
                    <div class="social-section">
                        <h4 class="social-title">Connect With Us</h4>
                        <div class="social-grid">
                            <!-- Loop through social media accounts -->
                            <ng-container *ngFor="let social of socialMedia">
                                <!-- Only show active social media links -->
                                <a *ngIf="social.active" [href]="social.url" target="_blank" 
                                    class="social-item" [style.color]="color">
                                    <!-- SVG icons para diferentes redes sociales -->
                                    <ng-container [ngSwitch]="social.name?.toLowerCase()">
                                        <!-- Facebook Icon -->
                                        <svg *ngSwitchCase="'facebook'" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                        </svg>
                                        
                                        <!-- Instagram Icon -->
                                        <svg *ngSwitchCase="'instagram'" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                                        </svg>
                                        
                                        <!-- Twitter/X Icon -->
                                        <svg *ngSwitchCase="'twitter'" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                                        </svg>
                                        
                                        <!-- LinkedIn Icon -->
                                        <svg *ngSwitchCase="'linkedin'" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                                        </svg>
                                        
                                        <!-- YouTube Icon -->
                                        <svg *ngSwitchCase="'youtube'" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                                        </svg>
                                        
                                        <!-- WhatsApp Icon -->
                                        <svg *ngSwitchCase="'whatsapp'" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.893 3.488"/>
                                        </svg>
                                        
                                        <!-- TikTok Icon -->
                                        <svg *ngSwitchCase="'tiktok'" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                                        </svg>
                                        
                                        <!-- Fallback icon for unknown social media -->
                                        <svg *ngSwitchDefault width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z"/>
                                            <circle cx="12" cy="12" r="3"/>
                                        </svg>
                                    </ng-container>
                                </a>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <!-- Navigation Sections -->
                <!-- Dynamic navigation sections based on middle array -->
                <div class="nav-section" *ngFor="let item of middle">
                    <!-- Section title with dynamic color -->
                    <h4 class="section-title" [style.color]="item.color">{{ item.title }}</h4>
                    
                    <!-- Navigation links -->
                    <nav class="nav-links">
                        <!-- Loop through quick links for each section -->
                        <a *ngFor="let link of item.quick_links" 
                            [style.color]="color" 
                            [hidden]="!link.active" 
                            [href]="link.href" 
                            class="nav-link">
                            {{ link.label }}
                        </a>
                    </nav>
                </div>

                <!-- Contact Section -->
                <!-- Contact information with phone and email -->
                <div class="contact-section">
                    <h4 class="section-title" [style.color]="colorRigth">Get In Touch</h4>
                    <div class="contact-grid">
                        
                        <!-- Phone Contact Card -->
                        <div class="contact-card">
                            <div class="contact-icon phone-icon">
                                <!-- Phone SVG icon -->
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                                </svg>
                            </div>
                            <div class="contact-info">
                                <span class="contact-label">Phone</span>
                                <!-- Clickable phone number usando la propiedad correcta -->
                                <a *ngIf="phone" [href]="'tel:' + phone" class="contact-value">{{ phone }}</a>
                                <span *ngIf="!phone" class="contact-value">No phone available</span>
                            </div>
                        </div>
                        
                        <!-- Email Contact Card -->
                        <div class="contact-card">
                            <div class="contact-icon email-icon">
                                <!-- Email SVG icon -->
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                                    <polyline points="22,6 12,13 2,6"/>
                                </svg>
                            </div>
                            <div class="contact-info">
                                <span class="contact-label">Email</span>
                                <!-- Clickable email address usando la propiedad correcta -->
                                <a *ngIf="email" [href]="'mailto:' + email" class="contact-value">{{ email }}</a>
                                <span *ngIf="!email" class="contact-value">No email available</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer Bottom -->
    <!-- Copyright, payment methods, and version information -->
    <div class="footer-bottom">
        <div class="container">
            <div class="bottom-content">
                
                <!-- Copyright Section -->
                <div class="copyright-section">
                    <p class="copyright-text">
                        <span class="copyright-symbol">©</span>
                        <!-- Dynamic current year -->
                        <span>{{ today | date:'y' }}</span>
                        <span class="powered-text">Powered by</span>
                        <!-- External link to ianos.app -->
                        <a href="https://ianos.app" target="_blank" class="powered-link">ianos.app</a>
                    </p>
                </div>
                
                <!-- Payment Methods Section -->
                <div class="payment-section">
                    <div class="payment-label">Secure Payments</div>
                    <div class="payment-grid">
                        <!-- Payment method icons -->
                        <div class="payment-card">
                            <img src="assets/images/icon/visa.png" alt="Visa">
                        </div>
                        <div class="payment-card">
                            <img src="assets/images/icon/mastercard.png" alt="Mastercard">
                        </div>
                        <div class="payment-card">
                            <img src="assets/images/icon/american-express.png" alt="American Express">
                        </div>
                    </div>
                </div>
                
                <!-- Version Section -->
                <div class="version-section">
                    <!-- Dynamic version badge -->
                    <div class="version-badge">v{{version_web}}</div>
                </div>
            </div>
        </div>
    </div>
</footer>

<style>
/* Variables mejoradas para mejor contraste */
:root {
    --primary-gradient: linear-gradient(135deg, #D6720F 0%, #FF8C42 100%);
    --secondary-gradient: linear-gradient(135deg, #D6720F 0%, #B85A00 100%);
    --accent-gradient: linear-gradient(135deg, #FF8C42 0%, #FFA366 100%);
    --dark-bg: #0a0a0a;
    --card-bg: #1a1a1a;
    --border-color: #2a2a2a;
    --text-primary: #ffffff; /* Blanco puro para mejor contraste */
    --text-secondary: #e0e0e0; /* Gris más claro para mejor visibilidad */
    --text-muted: #a0a0a0; /* Gris medio más claro */
    --shadow-sm: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    --shadow-md: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    --shadow-lg: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    --border-radius: 12px;
    --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 
    Newsletter Section Styles
    - Gradient background with overlay effects
    - Modern glassmorphism design
    - Responsive form layout
*/
.newsletter-container {
    position: relative;
    overflow: hidden;
}

.newsletter-bg {
    background: var(--primary-gradient);
    padding: 4rem 0;
    position: relative;
}

/* Decorative background overlay with multiple gradients */
.newsletter-bg::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
        radial-gradient(circle at 20% 80%, rgba(214, 114, 15, 0.4) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(255, 140, 66, 0.3) 0%, transparent 50%),
        radial-gradient(circle at 50% 50%, rgba(184, 90, 0, 0.2) 0%, transparent 70%);
    pointer-events: none;
}

.newsletter-wrapper {
    position: relative;
    z-index: 2;
}

.newsletter-content {
    color: white;
    padding-right: 2rem;
}

/* Glassmorphism badge design */
.newsletter-badge {
    display: inline-block;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.875rem;
    font-weight: 500;
    margin-bottom: 1rem;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.newsletter-heading {
    font-size: 3rem;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 1rem;
}

/* Gradient text effect for highlight words */
.gradient-text {
    background: linear-gradient(45deg, #FFD700, #FFA500, #FF8C42);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-shadow: 0 0 20px rgba(255, 140, 66, 0.3);
}

.newsletter-text {
    font-size: 1.125rem;
    opacity: 0.9;
    line-height: 1.6;
    margin-bottom: 0;
}

/* Modern form styling */
.modern-form {
    margin-top: 2rem;
}

.form-wrapper {
    display: flex;
    gap: 1rem;
    align-items: stretch;
}

.input-wrapper {
    flex: 1;
    position: relative;
}

/* Glassmorphism input design */
.modern-input {
    width: 100%;
    padding: 1rem 1.5rem;
    border: 2px solid rgba(255, 255, 255, 0.2);
    border-radius: var(--border-radius);
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    color: white;
    font-size: 1rem;
    transition: var(--transition);
}

.modern-input::placeholder {
    color: rgba(255, 255, 255, 0.7);
}

.modern-input:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.15);
}

/* Animated focus line effect */
.input-focus {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, #D6720F, #FF8C42);
    transform: scaleX(0);
    transition: transform 0.3s ease;
    box-shadow: 0 0 10px rgba(214, 114, 15, 0.5);
}

.modern-input:focus + .input-focus {
    transform: scaleX(1);
}

/* Modern button with hover animations */
.modern-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem 2rem;
    background: var(--secondary-gradient);
    border: none;
    border-radius: var(--border-radius);
    color: white;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: var(--transition);
    box-shadow: var(--shadow-md);
}

.modern-btn:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-lg);
}

.modern-btn svg {
    transition: transform 0.3s ease;
}

/* Arrow slide animation on hover */
.modern-btn:hover svg {
    transform: translateX(4px);
}

/* 
    Main Footer Styles
    - Dark theme with modern gradient overlays
    - Organized sections for brand, navigation, and contact
    - Multiple gradient layers for depth
*/
.main-footer {
    background: 
        linear-gradient(135deg, rgba(214, 114, 15, 0.1) 0%, rgba(255, 140, 66, 0.05) 25%, transparent 50%),
        linear-gradient(225deg, rgba(184, 90, 0, 0.08) 0%, rgba(214, 114, 15, 0.03) 40%, transparent 70%),
        radial-gradient(circle at 30% 40%, rgba(255, 140, 66, 0.15) 0%, transparent 50%),
        radial-gradient(circle at 70% 80%, rgba(214, 114, 15, 0.1) 0%, transparent 60%),
        var(--dark-bg);
    padding: 4rem 0;
    position: relative;
    overflow: hidden;
}

/* Animated gradient overlay */
.main-footer::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, 
        transparent 0%, 
        rgba(214, 114, 15, 0.3) 10%, 
        rgba(255, 140, 66, 0.8) 30%, 
        rgba(255, 163, 102, 1) 50%, 
        rgba(255, 140, 66, 0.8) 70%, 
        rgba(214, 114, 15, 0.3) 90%, 
        transparent 100%
    );
    animation: gradientShimmer 3s ease-in-out infinite;
}

/* Floating gradient orbs for ambient lighting */
.main-footer::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: 
        radial-gradient(circle at 20% 20%, rgba(255, 140, 66, 0.08) 0%, transparent 25%),
        radial-gradient(circle at 80% 60%, rgba(214, 114, 15, 0.06) 0%, transparent 30%),
        radial-gradient(circle at 60% 90%, rgba(255, 163, 102, 0.04) 0%, transparent 35%);
    animation: floatingGradients 20s linear infinite;
    pointer-events: none;
    z-index: 1;
}

/* Responsive grid layout for footer sections */
.footer-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 3rem;
    margin-bottom: 3rem;
    position: relative;
    z-index: 2;
}

.footer-brand-section {
    grid-column: span 1;
}

.brand-container {
    margin-bottom: 2rem;
}

.logo-wrapper {
    margin-bottom: 1.5rem;
}

.brand-logo {
    max-width: 9rem;
    height: auto;
    filter: brightness(1.1);
}

.brand-description {
    font-size: 1rem;
    line-height: 1.6;
    color: var(--text-secondary);
    margin-bottom: 0;
}

/* Social media section */
.social-section {
    margin-top: 2rem;
}

.social-title {
    color: var(--text-primary);
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: 1rem;
}

.social-grid {
    display: flex;
    gap: 1rem;
}

/* Social media icon buttons with hover effects */
.social-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
    color: var(--text-secondary);
    transition: var(--transition);
    text-decoration: none;
}

.social-item:hover {
    background: var(--primary-gradient);
    border-color: transparent;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(214, 114, 15, 0.4);
}

.social-item i {
    font-size: 1.125rem;
}

/* Navigation sections */
.nav-section {
    display: flex;
    flex-direction: column;
}

.section-title {
    color: var(--text-primary);
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
    position: relative;
}

/* Underline accent for section titles */
.section-title::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 24px;
    height: 2px;
    background: white;
    border-radius: 2px;
    box-shadow: 0 0 8px rgba(255, 255, 255, 0.6);
}

.nav-links {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

/* Navigation links with bullet points and hover effects */
.nav-link {
    color: var(--text-secondary);
    text-decoration: none;
    font-size: 0.95rem;
    transition: var(--transition);
    position: relative;
    padding-left: 1rem;
}

/* Bullet point before each nav link */
.nav-link::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 4px;
    height: 4px;
    background: var(--text-muted);
    border-radius: 50%;
    transform: translateY(-50%);
    transition: var(--transition);
}

.nav-link:hover {
    color: var(--text-primary);
    padding-left: 1.25rem;
}

.nav-link:hover::before {
    background: linear-gradient(45deg, #D6720F, #FF8C42);
    transform: translateY(-50%) scale(1.5);
    box-shadow: 0 0 8px rgba(214, 114, 15, 0.6);
}

/* Contact section */
.contact-section {
    display: flex;
    flex-direction: column;
}

.contact-grid {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

/* Contact cards with enhanced gradient effects */
.contact-card {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.25rem;
    background: 
        linear-gradient(135deg, rgba(255, 255, 255, 0.02) 0%, rgba(255, 255, 255, 0.01) 100%),
        var(--card-bg);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
    transition: var(--transition);
    position: relative;
    overflow: hidden;
}

/* Gradient shine effect on hover */
.contact-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, 
        transparent 0%, 
        rgba(255, 140, 66, 0.1) 50%, 
        transparent 100%
    );
    transition: left 0.6s ease;
    pointer-events: none;
}

.contact-card:hover {
    background: 
        linear-gradient(135deg, rgba(214, 114, 15, 0.15) 0%, rgba(255, 140, 66, 0.08) 100%),
        var(--card-bg);
    border-color: rgba(214, 114, 15, 0.4);
    transform: translateY(-2px);
    box-shadow: 
        0 8px 25px rgba(214, 114, 15, 0.2),
        0 0 40px rgba(255, 140, 66, 0.1);
}

.contact-card:hover::before {
    left: 100%;
}

.contact-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: var(--border-radius);
    flex-shrink: 0;
}

/* Different colored icons for phone and email */
.phone-icon {
    background: linear-gradient(135deg, rgba(214, 114, 15, 0.2), rgba(255, 140, 66, 0.2));
    color: #D6720F;
    border: 1px solid rgba(214, 114, 15, 0.2);
}

.email-icon {
    background: linear-gradient(135deg, rgba(255, 140, 66, 0.2), rgba(255, 163, 102, 0.2));
    color: #FF8C42;
    border: 1px solid rgba(255, 140, 66, 0.2);
}

.contact-info {
    flex: 1;
}

.contact-label {
    display: block;
    color: var(--text-secondary); /* Cambio de rgba(255, 255, 255, 0.7) a variable más visible */
    font-size: 0.875rem;
    margin-bottom: 0.25rem;
    font-weight: 500;
}

.contact-value {
    color: var(--text-primary); /* Cambio a blanco puro para mayor visibilidad */
    text-decoration: none;
    font-weight: 500;
    transition: var(--transition);
}

.contact-value:hover {
    color: #FF8C42; /* Cambio a color naranja para mejor visibilidad en hover */
    text-shadow: 0 0 8px rgba(255, 140, 66, 0.8);
}

/* 
    Footer Bottom Styles
    - Copyright, payment methods, and version
    - Orange gradient background
*/
.footer-bottom {
    background: #D6720F;
    padding: 1.5rem 0;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    position: relative;
    overflow: hidden;
}

/* Decorative background overlay */
.footer-bottom::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
        radial-gradient(circle at 30% 80%, rgba(255, 140, 66, 0.2) 0%, transparent 50%),
        radial-gradient(circle at 70% 20%, rgba(184, 90, 0, 0.3) 0%, transparent 50%);
    pointer-events: none;
}

.bottom-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    position: relative;
    z-index: 2;
}

/* Copyright section */
.copyright-section {
    flex: 1;
}

.copyright-text {
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.9rem;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.copyright-symbol {
    color: rgba(255, 255, 255, 0.6);
}

.powered-text {
    color: rgba(255, 255, 255, 0.6);
}

.powered-link {
    color: white;
    text-decoration: none;
    font-weight: 500;
    transition: var(--transition);
    text-shadow: 0 0 8px rgba(255, 255, 255, 0.3);
}

.powered-link:hover {
    color: white;
    text-shadow: 0 0 12px rgba(255, 255, 255, 0.8);
}

/* Payment methods section */
.payment-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
}

.payment-label {
    color: var(--text-muted);
    font-size: 0.8rem;
    font-weight: 500;
}

.payment-grid {
    display: flex;
    gap: 0.75rem;
}

/* Payment method cards */
.payment-card {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 32px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 6px;
    transition: var(--transition);
    backdrop-filter: blur(10px);
}

.payment-card:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    border-color: rgba(255, 255, 255, 0.3);
}

.payment-card img {
    height: 20px;
    width: auto;
    filter: brightness(0.9);
}

/* Version badge */
.version-section {
    display: flex;
    align-items: center;
}

.version-badge {
    background: rgba(255, 255, 255, 0.15);
    color: white;
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 500;
    font-family: monospace;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(10px);
}

/* 
    Responsive Design
    - Mobile-first approach
    - Breakpoints for different screen sizes
*/
@media (max-width: 1200px) {
    .footer-grid {
        grid-template-columns: 1fr 1fr 1fr;
        gap: 2rem;
    }
    
    .footer-brand-section {
        grid-column: span 3;
    }
}

@media (max-width: 768px) {
    .newsletter-bg {
        padding: 2.5rem 0;
    }
    
    .newsletter-content {
        padding-right: 0;
        margin-bottom: 2rem;
    }
    
    .newsletter-heading {
        font-size: 2.25rem;
    }
    
    .form-wrapper {
        flex-direction: column;
        gap: 1rem;
    }
    
    .footer-grid {
        grid-template-columns: 1fr;
        gap: 2rem;
    }
    
    .footer-brand-section {
        grid-column: span 1;
    }
    
    .bottom-content {
        flex-direction: column;
        text-align: center;
        gap: 1rem;
    }
    
    .payment-section {
        order: -1;
    }
    
    .social-grid {
        justify-content: center;
    }
}

@media (max-width: 480px) {
    .newsletter-heading {
        font-size: 1.875rem;
    }
    
    .main-footer {
        padding: 2.5rem 0;
    }
    
    .footer-grid {
        gap: 1.5rem;
    }
    
    .contact-card {
        padding: 1rem;
    }
    
    .payment-grid {
        flex-wrap: wrap;
        justify-content: center;
    }
}
</style>
<!--footer section end -->